const $ = require('jquery');

(function () {

    $('.bpsection').click(function (e) {
        $(".section").hide();
        $("#bp_"+this.id).show();
        $('.bpsection').removeClass('selected');
        $(this).addClass('selected');
        //here
    });

    $('.bpsection').first().click();

    if ( $('#program').val() != undefined ) {
        axios.get( {
            // type: "GET",
            dataType : 'json',
            url: location.protocol+"//"+window.location.host+"/action-plans/goals?program_id="+$('#program').val()+"&sections="+$('#sections').val(), 
            success: function( data, status, xhr ) {
                if ( data.data.length > 0 ) {
                    mygoals = $('#mygoals');
                    mygoals.empty();
                    for (var i = 0; i < data.data.length; i++) { 
                        var ap = data.data[i];
                        console.log(ap.goal.best_practice.section);
                        var str = '<tr class="selected_goals" id="goal_'+ap.goal_id+'"><td class="cell_bottom"><div class="left goal_btn"><img class="btn-image" src="/images/action_plans/'+ap.goal.best_practice.section.btn_image+'" /></div><div class="a_goal">'+ap.goal.best_practice.text+'</div><div class="close_wrapper"><a class="close right deleteap" id="delete_'+ap.id+'"><i class="fas fa-times"></i></a></div></td></tr>';
                        var html = $.parseHTML( str );
                        mygoals.append(html);
                    }
                    
                } else {
                    mygoals = $('#mygoals');
                    mygoals.empty();
                    mygoals.html('<tbody><tr id="no_goals_selected" class=""><td class="cell_bottom">Add goals by selecting them above.</td></tr></tbody>');
                }
        

            }
        });
    }
    $('.refreshMyGoals').click( function (e) {
        var prot = location.protocol;
        console.log(prot);
            axios.get( {
                // type: "GET",
                dataType : 'json',
                url: prot+"//"+window.location.host+"/action-plans/goals?program=34", 
                success: function( data, status, xhr ) {
                    console.log(data);

                }
            });
        
    });
}($));